import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import {
  FaMapMarkerAlt, FaHeart,
  FaRegCalendarAlt, FaClock,
  FaHandHoldingHeart
} from 'react-icons/fa';
import { BsFillPlayFill, BsPauseFill, BsFlower3 } from 'react-icons/bs';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import RSVPSection from './compoments/RSVPSection';
import useAudio from './compoments/useAudio';
import { FloralDecoration, FloatingElements } from './compoments/Unitils';
import CountdownTimer from './compoments/CountdownTimer';
import PhotoGallery from './compoments/PhotoGallery';
import { ToastProvider } from './compoments/ToastProvider';
import { map } from 'framer-motion/client';
function App() {

  const [timeLeft, setTimeLeft] = useState({
    days: 0, hours: 0, minutes: 0, seconds: 0,
  });

  useEffect(() => {
    const timer = setInterval(() => {
      const weddingDate = new Date('2024-12-07T06:00:00').getTime();
      const now = new Date().getTime();
      const difference = weddingDate - now;

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((difference % (1000 * 60)) / 1000),
        });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const {
    playing,
    loading,
    play,
    pause,
    isIOS,
    hasInitialClick,
    setHasInitialClick
  } = useAudio('/Em Đồng Ý (I Do) - Đức Phúc, 911.mp3');

  useEffect(() => {
    const handleFirstClick = () => {
      if (!hasInitialClick && !loading) {
        play();
        setHasInitialClick(true);
        // Remove listener after first click
        document.removeEventListener('click', handleFirstClick);
      }
    };

    // Chỉ add listener nếu chưa có click đầu tiên và không phải iOS
    if (!hasInitialClick && !isIOS) {
      document.addEventListener('click', handleFirstClick);
    }

    return () => {
      document.removeEventListener('click', handleFirstClick);
    };
  }, [hasInitialClick, loading, play, setHasInitialClick, isIOS]);

  // Xử lý click vào nút
  const handleButtonClick = (e) => {
    e.stopPropagation();
    if (playing) {
      pause();
    } else if (hasInitialClick || isIOS) {
      // Chỉ play qua nút sau lần click đầu tiên hoặc trên iOS
      play();
    }
  };

  const [showNotification, setShowNotification] = useState(true); // Mặc định là true lần đầu
  const [initialLoad, setInitialLoad] = useState(true); // Để xác định lần đầu vào trang

  useEffect(() => {
    if (initialLoad) {
      const timeout = setTimeout(() => {
        setShowNotification(false);
        setInitialLoad(false); // Sau khi ẩn, đánh dấu lần đầu đã xử lý
      }, 3000);
      return () => clearTimeout(timeout); // Dọn dẹp timeout
    }
  }, [initialLoad]);

  useEffect(() => {
    if (showNotification && !initialLoad) {
      const timeout = setTimeout(() => setShowNotification(false), 3000);
      return () => clearTimeout(timeout); // Dọn dẹp timeout
    }
  }, [showNotification, initialLoad]);



  return (
    <ToastProvider>
      <AnimatePresence>
        <div className="relative min-h-screen bg-gradient-to-b from-rose-50 via-white to-rose-50">
          {/* Music Control */}
          <div className="fixed bottom-6 right-6 z-50">
            <motion.button
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              className={`relative p-4 rounded-full shadow-xl
      bg-rose-400/20 backdrop-blur-sm text-white
      transition-all duration-500
      hover:bg-rose-400 hover:backdrop-blur-md hover:scale-110
      before:content-[''] before:absolute before:inset-0
      before:rounded-full before:border-2 before:border-rose-500
      before:animate-pulse-border
      after:content-[''] after:absolute after:inset-[-4px]
      after:rounded-full after:border-2 after:border-rose-500
      after:animate-pulse-border-delay`}
              onClick={handleButtonClick}
              disabled={loading}
              onMouseEnter={() => setShowNotification(true)}
              onMouseLeave={() => setShowNotification(false)}
            >
              {playing ?
                <BsPauseFill size={28} className="text-rose-500" /> :
                <BsFillPlayFill size={28} className="text-rose-500" />
              }
            </motion.button>

            {/* Notification remains unchanged */}
            {!playing && !loading && (
              <AnimatePresence>
                {showNotification && (
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 20 }}
                    transition={{ duration: 0.3 }}
                    className="fixed bottom-24 right-5 z-50 bg-white p-3 rounded-lg shadow-lg text-sm text-gray-600 max-w-xs"
                  >
                    {!hasInitialClick && !isIOS
                      ? 'Nhấn vào bất kỳ đâu để bắt đầu nghe nhạc nền 🎵'
                      : 'Nhấn vào nút để nghe nhạc nền 🎵'}
                  </motion.div>
                )}
              </AnimatePresence>
            )}
          </div>

          {/* Hero Section */}
          <header className="relative h-screen flex items-center justify-center overflow-hidden">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 2 }}
              className="absolute inset-0"
            >
              <div className="absolute inset-0 bg-gradient-to-b from-rose-900/60 via-rose-900/40 to-rose-900/60 z-10" />
              <img
                src="/assets/images/cover.jpeg"
                alt="Wedding Hero"
                className="w-full h-full md:h-auto object-cover scale-110 animate-slow-zoom"
              />
            </motion.div>

            <FloatingElements />
            <FloralDecoration />

            <div className="relative z-20 text-center px-6">
              <motion.div
                initial={{ y: 50, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 1.5, delay: 0.5 }}
                className="space-y-10"
              >
                <div className="inline-block mb-8">
                  <motion.div
                    animate={{
                      rotate: [0, 10, -10, 0],
                      scale: [1, 1.1, 1]
                    }}
                    transition={{ duration: 3, repeat: Infinity }}
                  >
                    <BsFlower3 className="text-rose-200 text-5xl mx-auto mb-4" />
                  </motion.div>
                  <p className="text-2xl text-rose-100 font-dancing">Save Our Date</p>
                </div>

                <motion.h1
                  className="text-6xl sm:text-7xl md:text-8xl lg:text-9xl font-dancing text-white mb-8 leading-tight"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.8 }}
                >
                  Văn Nhất <span className="text-rose-200 animate-pulse">&</span> Thục Hiền
                </motion.h1>

                <p className="text-2xl md:text-3xl text-white font-dancing">
                  Trân trọng kính mời
                </p>

                <CountdownTimer timeLeft={timeLeft} />
              </motion.div>
            </div>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.5 }}
              className="absolute bottom-10 text-center transform -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce"
            >
              <FaHeart className="text-pink-400 text-2xl" />
              <p className="text-rose-100 font-playfair">Cuộn xuống để xem thêm</p>
            </motion.div>
          </header>

          {/* Photo Gallery */}
          <PhotoGallery />

          {/* Wedding Details */}
          <section className="py-24 px-6 relative overflow-hidden">
            <FloralDecoration />
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
              className="max-w-5xl mx-auto relative z-10"
            >
              <div className="text-center mb-16">
                <motion.div
                  animate={{
                    scale: [1, 1.2, 1],
                    rotate: [0, 5, -5, 0]
                  }}
                  transition={{ duration: 4, repeat: Infinity }}
                >
                  <BsFlower3 className="text-rose-400 text-4xl mx-auto mb-6" />
                </motion.div>
                <h2 className="text-5xl md:text-6xl font-greatVibes text-gray-800">
                  Thông Tin Lễ Cưới
                </h2>
              </div>

              <div className="grid md:grid-cols-3 gap-10">
                {[
                  {
                    title: 'Tiệc Cưới Nhà Gái',
                    time: '16:00',
                    date: '07/12/2024',
                    location: 'Tư gia nhà gái',
                    address: 'TDP Vinh Quang 1 - Châu Sơn - Sông Công - Thái Nguyên',
                    image: 'https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d1121.7062827899538!2d105.81917826962751!3d21.45930999876874!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjHCsDI3JzMzLjUiTiAxMDXCsDQ5JzExLjQiRQ!5e1!3m2!1svi!2s!4v1732559402768!5m2!1svi!2s',
                    map: 'https://maps.app.goo.gl/TXU1fg4nMFSzokpB9'
                  },
                  {
                    title: 'Lễ Vu Quy',
                    time: '07:00',
                    date: '08/12/2024',
                    location: 'Tư gia nhà gái',
                    address: 'TDP Vinh Quang 1 - Châu Sơn - Sông Công - Thái Nguyên',
                    image: 'https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d1121.7062827899538!2d105.81917826962751!3d21.45930999876874!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjHCsDI3JzMzLjUiTiAxMDXCsDQ5JzExLjQiRQ!5e1!3m2!1svi!2s!4v1732559402768!5m2!1svi!2s',
                    map: 'https://maps.app.goo.gl/TXU1fg4nMFSzokpB9'
                  },
                  {
                    title: 'Tiệc Cưới Nhà Trai & Lễ Thành Hôn',
                    time: '08:00',
                    date: '08/12/2024',
                    location: 'Tư gia nhà trai',
                    address: 'Cầu Giao - Minh Đức - Phổ Yên - Thái Nguyên',
                    image: 'https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d471.67685816426274!2d105.80711129675446!3d21.441543931944363!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjHCsDI2JzMwLjIiTiAxMDXCsDQ4JzI2LjQiRQ!5e1!3m2!1svi!2s!4v1732558916659!5m2!1svi!2s',
                    map: 'https://maps.app.goo.gl/q9W8jDc6MaJVcnGN6'
                  }
                ].map((event, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.3 }}
                    className="relative flex flex-col h-full bg-white p-8 rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 border-2 border-rose-100 group"
                  >
                    <div className="relative mb-8 rounded-2xl overflow-hidden">
                      <iframe
                        src={event.image}
                        style={{ border: 0 }}
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Wedding Location Map"
                        className="w-full h-64 object-cover transition-transform duration-700"
                      ></iframe>
                    </div>

                    <h3 className="text-3xl font-greatVibes text-gray-800 mb-6">{event.title}</h3>

                    <div className="space-y-4 text-gray-600 font-dancing text-lg">
                      <p className="flex items-center gap-3">
                        <FaMapMarkerAlt className="text-rose-400 text-xl" />
                        {event.location}
                      </p>
                      <p className="flex items-center gap-3">
                        <FaRegCalendarAlt className="text-rose-400 text-xl" />
                        {event.date}
                      </p>
                      <p className="flex items-center gap-3">
                        <FaClock className="text-rose-400 text-xl" />
                        {event.time}
                      </p>
                      <p className="flex items-center gap-3">
                        <FaMapMarkerAlt className="text-rose-400 text-xl" />
                        {event.address}
                      </p>
                    </div>

                    <motion.a
                      href={event.map}
                      target="_blank"
                      whileHover={{ scale: 1.05 }}
                      className="mt-auto w-full bg-rose-50 hover:bg-rose-100 text-rose-600 py-4 rounded-xl font-dancing text-xl transition-colors duration-300 inline-block text-center no-underline cursor-pointer"
                    >
                      Xem bản đồ
                    </motion.a>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          </section>

          {/* RSVP Section */}
          <RSVPSection />

          {/* Wedding Gift Section */}
          <section className="py-24 px-6 relative overflow-hidden">
            <FloralDecoration />
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
              className="max-w-5xl mx-auto text-center relative z-10"
            >
              <motion.div
                animate={{
                  scale: [1, 1.2, 1],
                  rotate: [0, 5, -5, 0]
                }}
                transition={{ duration: 4, repeat: Infinity }}
              >
                <BsFlower3 className="text-rose-400 text-4xl mx-auto mb-6" />
              </motion.div>

              <h2 className="text-5xl md:text-6xl font-greatVibes text-gray-800 mb-8">Mừng Cưới</h2>

              <p className="text-gray-600 max-w-2xl mx-auto mb-16 font-dancing text-xl italic">
                Sự hiện diện của quý vị là niềm vinh hạnh của chúng tôi.
                Nếu không thể đến dự, quý vị có thể gửi lời chúc qua:
              </p>

              <div className="grid md:grid-cols-2 gap-10 max-w-4xl mx-auto">
                {[
                  {
                    title: 'Chú rể - Văn Nhất',
                    name: 'TRAN VAN NHAT',
                    bank: 'MB Bank',
                    account: '2511662886',
                    qr: 'https://img.vietqr.io/image/MB-2511662886-qr_only.png',
                    avatar: '/assets/images/avatars/nhat.jpg'
                  },
                  {
                    title: 'Cô dâu - Thục Hiền',
                    name: 'NGO THI THUC HIEN',
                    bank: 'TP Bank',
                    account: '22621628888',
                    qr: 'https://img.vietqr.io/image/TPB-22621628888-qr_only.png',
                    avatar: '/assets/images/avatars/hien.jpeg'
                  },
                ].map((person, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.3 }}
                    className="bg-white p-10 rounded-3xl shadow-xl border-2 border-rose-100 hover:shadow-2xl transition-all duration-500"
                  >
                    <div className="relative mb-8">
                      <div className="w-32 h-32 mx-auto relative">
                        <img
                          src={person.avatar}
                          alt={person.title}
                          className="w-full h-full rounded-full object-cover border-4 border-rose-100"
                        />
                        <motion.div
                          animate={{ scale: [1, 1.2, 1] }}
                          transition={{ duration: 2, repeat: Infinity }}
                          className="absolute -bottom-2 left-1/2 transform -translate-x-1/2"
                        >
                          <FaHeart className="text-rose-400 text-2xl" />
                        </motion.div>
                      </div>
                    </div>

                    <h3 className="text-3xl font-greatVibes mb-6">{person.title}</h3>

                    <motion.div
                      whileHover={{ scale: 1.02 }}
                      className="bg-rose-50/50 p-6 rounded-2xl space-y-4 backdrop-blur-sm"
                    >
                      <div className="bg-white p-4 rounded-xl shadow-md">
                        <img
                          src={person.qr}
                          alt={`QR ${person.title}`}
                          className="w-56 h-56 mx-auto mb-4"
                        />
                      </div>

                      <div className="space-y-2 font-dancing text-lg">
                        <p className="text-gray-700 font-medium">{person.name}</p>
                        <p className="text-gray-600">{person.bank}</p>
                        <p className="text-gray-600 font-mono text-xl">{person.account}</p>
                      </div>
                    </motion.div>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          </section>

          {/* Footer */}
          <footer className="py-20 px-6 bg-gradient-to-b from-white to-rose-50 relative overflow-hidden">
            <FloralDecoration />
            <div className="max-w-4xl mx-auto text-center relative z-10">
              <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 1 }}
                className="space-y-8"
              >
                <div className="w-32 h-32 mx-auto relative">
                  <img
                    src="/assets/images/avatars/capdoi.jpeg"
                    alt="N&H"
                    className="w-full h-full object-cover rounded-full border-4 border-rose-200"
                  />
                  <motion.div
                    animate={{ scale: [1, 1.2, 1] }}
                    transition={{ duration: 2, repeat: Infinity }}
                    className="absolute inset-0 border-2 border-rose-300 rounded-full"
                  />
                </div>

                <div>
                  <h2 className="text-4xl font-greatVibes text-gray-800 mb-2">Văn Nhất & Thục Hiền</h2>
                  <p className="text-xl text-gray-600 font-dancing">07.12.2024</p>
                </div>

                <p className="mt-12 text-gray-500 font-dancing text-lg">
                  © 2024 - From <a href="https://quanhd.net" className="text-rose-500 hover:underline">HDQuanDev</a> With Love
                </p>
              </motion.div>
            </div>
          </footer>
        </div>
      </AnimatePresence>
    </ToastProvider>
  );
}

export default App;